import { Props as DeprecatedAvailabilityProps } from 'coaching/components/DeprecatedCoachingAvailabilityView/CoachingAvailabilityView';
import GetCoachAvailabilitiesAndTimezoneContainer from 'coaching/containers/GetCoachAvailabilitiesAndTimezoneContainer';
import React, { ReactNode, useState } from 'react';
import { getWeeklyTimeframeISOStrings } from 'coaching/lib/timeIntervals';
import TimezoneHelper from 'lib/timezones';
// @ts-ignore
import User from 'entities/User';

type Props = {
  user: User;
  children: (props: DeprecatedAvailabilityProps) => ReactNode;
};

type State = {
  timezone: string;
  weekOffset: number;
};

export default function CoachingAvailabilityContainer(props: Props) {
  const [state, setState] = useState<State>({
    weekOffset: 0,
    // try and ascertain the user's timezone, and default to the first value
    // in the select options if we cannot
    timezone:
      TimezoneHelper.userTimezoneDefaultValue ?? TimezoneHelper.USTimezoneSelectOptions[0].value,
  });
  const advanceWeekOffset = () => {
    setState({ ...state, weekOffset: state.weekOffset + 1 });
  };

  const regressWeekOffset = () => {
    setState({ ...state, weekOffset: state.weekOffset - 1 });
  };

  const userUuid = props.user.getUuid();
  const { startDateTime, endDateTime } = getWeeklyTimeframeISOStrings(state.weekOffset);
  const availabilityQueryProps = {
    coachUuid: userUuid,
    startDateTime,
    endDateTime,
  };

  return (
    <GetCoachAvailabilitiesAndTimezoneContainer queryVariables={availabilityQueryProps}>
      {({ loading, error, data }) => {
        return props.children({
          weekOffset: state.weekOffset,
          availabilityQuery: availabilityQueryProps,
          onAdvanceWeekOffset: advanceWeekOffset,
          onRegressWeekOffset: regressWeekOffset,
          timezone: data?.coaching?.findCoachForUserUuid.coach.timezone!,
          loadingSchedule: loading,
          errorMessage: error?.message,
          existingAvailabilities: data?.coaching?.coachAvailability.availabilities,
          existingAvailabilityExceptions: data?.coaching?.coachAvailability.availabilityExceptions,
        });
      }}
    </GetCoachAvailabilitiesAndTimezoneContainer>
  );
}
